import { addMonths, format } from 'date-fns'
import {
  isRmaLgmCommodityCode,
  isRmaLrpCommodityCode,
  RmaLgmCommodityCodeByName,
  RmaLgmCommodityNameByCode,
  RmaLrpCommodityCodes,
  RmaLrpCommodityNameByCode,
} from '@harvestiq/constants'
import { range } from './array'
import { lgmDateFormatFns } from './constants'

export const lgmCattleOptions = ['Calf Finishing', 'Yearling Finishing']
export const lgmSwineOptions = [
  'Finishing Operation',
  'SEW Operation',
  'Farrow to Finish',
]

export const cattleOptions = lgmCattleOptions.map(
  option => `Cattle - ${option}`,
)
const swineOptions = lgmSwineOptions.map(option => `Swine - ${option}`)

export const commodityTypeOptions = [...cattleOptions, ...swineOptions]

export const finishingTypeOptionMap = [
  ...cattleOptions,
  ...swineOptions,
].reduce((acc, crr) => {
  const [_, val] = crr.split(' - ')
  acc[crr] = val
  return acc
}, {})

export const getCommodityCode = commodityType => {
  // Extract the commodity from the type
  const commodityName = commodityType.split(' - ')[0]
  const commodityCode = RmaLgmCommodityCodeByName[commodityName]
  return commodityCode
}

export const makeCoverageCommodityLabel = (commodityCode, commodityType) => {
  if (isRmaLrpCommodityCode(commodityCode)) {
    const commodityName = RmaLrpCommodityNameByCode[commodityCode]
    return `${commodityName} - ${commodityType}`
  }
  if (isRmaLgmCommodityCode(commodityCode)) {
    const commodityName = RmaLgmCommodityNameByCode[commodityCode]
    return `${commodityName} - ${commodityType}`
  }

  return commodityType
}

export const numberOfHeadParameters = {
  limit: {
    [RmaLrpCommodityCodes.SWINE]: 70000,
    [RmaLrpCommodityCodes.FED_CATTLE]: 12000,
    [RmaLrpCommodityCodes.FEEDER_CATTLE]: 12000,
  },
  helperText: {
    [RmaLrpCommodityCodes.SWINE]: 'Swine max limit is 70,000',
    [RmaLrpCommodityCodes.FED_CATTLE]: 'Fed Cattle max limit is 12,000',
    [RmaLrpCommodityCodes.FEEDER_CATTLE]: 'Feeder Cattle max limit is 12,000',
  },
}

export const commodityTypeOptionsByCommodityName = {
  Cattle: {
    commodities: ['Calf Finishing', 'Yearling Finishing'],
    deductible: range(0, 150, 10),
    targetMarketLength: 10,
  },
  Swine: {
    commodities: ['Farrow to Finish', 'Finishing Operation', 'SEW Operation'],
    deductible: range(0, 20, 2),
    targetMarketLength: 5,
  },
}

export const getMarketingMonths = (
  commodity,
  date = new Date(),
  marketingMonths = {},
) => {
  date.setDate(1)

  const commodityTypeMaxLength =
    commodityTypeOptionsByCommodityName[commodity].targetMarketLength

  const marketingMonthsMap = new Map()

  for (let i = 1; i <= commodityTypeMaxLength; i++) {
    const updatedDate = addMonths(date, i + 1)
    const formattedMonth = format(updatedDate, lgmDateFormatFns)
    marketingMonthsMap.set(formattedMonth, marketingMonths[formattedMonth] ?? 0)
  }
  return marketingMonthsMap
}
